var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .prefix__cls-3{fill:#fff}\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "prefix__Warning",
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_947",
    fill: "none",
    d: "M25.945 0v24h24V0zm11 16h2v2h-2zm2-2h-2v-4h2z",
    "data-name": "Path 947",
    transform: "translate(-25.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Path_946",
    d: "M37.945 2l-11 19h22zm1 16h-2v-2h2zm-2-4v-4h2v4z",
    "data-name": "Path 946",
    transform: "translate(-25.945)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1244",
    d: "M0 0H2V2H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 1244",
    transform: "translate(11 16)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "prefix__Rectangle_1245",
    d: "M0 0H2V4H0z",
    className: "prefix__cls-3",
    "data-name": "Rectangle 1245",
    transform: "translate(11 10)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/Warning.8ed2f4838e372488b2b5c61733e0d1fe.svg";
export { ForwardRef as ReactComponent };